var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMegaphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FCB115",
  d: "m7.191 19.492-4.253.5 1.29 12.846 4.254-.5zM37.558 4.76l-4.253.5 3.508 34.919 4.253-.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCB115",
  d: "M38.334 38.14 6.6 30.7l-.921-9.168L35.196 6.9z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB7900",
  d: "m7.319 20.72-1.64.814.92 9.167 1.764.413zM33.554 7.713l3.015 30.013 1.763.413L35.194 6.9z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCB115",
  d: "m24.523 31.816-1.271 6.328-6.69-1.57 1.272-6.33-2.509-.588-1.816 9.04 11.707 2.75 1.815-9.04z"
})));
export default SvgMegaphone;